import { FC, RefObject } from "react";
import { useTranslation } from "react-i18next";

import {
  ClientCategoryDto,
  ClientDto,
} from "../../modules/Admin/ClientManagement/types";
import { activeCategories, getCategoryName } from "../config/categories";
import { REDESIGN_NS } from "../i18n";
import { getPortalName, openPortal } from "../lib/openPortal";

interface Props {
  clients: ClientDto[];
  categories: ClientCategoryDto[];
  isOpen: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  panelRef: RefObject<HTMLDivElement>;
  /** Header ölçüp veriyor: panel "Portal Seçimi" öğesinin altına hizalanır. */
  right: number | null;
}

/** Boş kategoriler gösterilmez. */
const MegaMenu: FC<Props> = ({
  clients,
  categories,
  isOpen,
  onMouseEnter,
  onMouseLeave,
  panelRef,
  right,
}) => {
  const { i18n } = useTranslation(REDESIGN_NS);

  // Pasif kategoriler ve kategorisi tanınmayan portaller menüye girmez.
  const groups = activeCategories(categories)
    .map((category) => ({
      category,
      items: clients.filter((client) => client.clientCategoryId === category.id),
    }))
    .filter((group) => group.items.length > 0);

  if (groups.length === 0) return null;

  const columns = Math.min(groups.length, 3);

  return (
    <div
      className={
        "sso-rd__megamenu" +
        (columns < 3 ? " is-cols-" + columns : "") +
        (isOpen ? " is-open" : "")
      }
      ref={panelRef}
      style={right != null ? { right } : undefined}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {groups.map(({ category, items }) => (
        <div className="sso-rd__megamenu-col" key={category.id}>
          <div className="sso-rd__megamenu-title">
            {getCategoryName(category, i18n.language)}
          </div>
          {items.map((client) => {
            const name = getPortalName(client, i18n.language);
            return (
              <button
                key={client.id}
                type="button"
                className="sso-rd__megamenu-link"
                title={name}
                onClick={() => openPortal(client)}
              >
                {name}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default MegaMenu;
